module.exports = __webpack_public_path__ + "img/IMG_2248_L_Foamcore.9154e507.jpg";